<template>
<div class="nav-buttons">
  <router-link aria-label="Página anterior" v-if="screenTrack[0] >= 1" :to="'/'+mod.modurl+'/'+ (screenTrack[0]-1)" @click.native.prevent="guardarubicacion()" class="flechas-nav fle-ant animated fadeIn"></router-link>
  <span v-if="currentPage > 0">Pantalla <strong>{{screenTrack[0]}}</strong> de <strong>{{screenTrack[1]}}</strong></span>
  <router-link aria-label="Página siguiente" v-if="nextPant" :to="'/'+mod.modurl+'/'+ (screenTrack[0]+1)" @click.native.prevent="guardarubicacion()" class="flechas-nav fle-sig animated fadeIn"></router-link>
</div>
</template>

<script>
import ScormMix from '../js/mixins/scormmixins'
export default {
  props: {
    mod: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    nextPant() {
      return this.$store.state.nextPant;
    },
    screenTrack() {
      return this.$store.state.screens;
    },
    currentPage() {
      return Math.floor(this.$route.params.unipage);
    }
  },
  mixins: [ScormMix]
};
</script>

<style lang="scss">
/* Flechas de navegacion

  IMPORTANTE: Estos estilos se encuentran disponibles para todo el proyecto
  con el fin de si se necesita emular el comportamiento de la flecha en alguna pantalla
  sin necesidad de mantener la lógica, se puede copiar y pegar solo el html y los estilos 
  se van a aplicar automáticamente.
 */
 .nav-buttons {
   position: absolute;
   bottom: 1rem;
   width: 100vw;
   text-align: center;
   font-family: Helveticalstd;
   display: flex;
   justify-content: center;
   align-items: center;
   p {margin: 0}
   
 }
.flechas-nav,
.flechas-nav-blan {
  width: 41px;
  height: 41px;
  margin: 0 15px;
  transition: transform 250ms;
  cursor: pointer;
  background-image: url("../assets/imagenes_compartidas/flechas-nav.png");
  z-index: 3;
  border-radius: 100%;

  &.fle-ant {
    left: 55px;
    background-position: -43px 0;
  }

  &.fle-sig {
    right: 23px;
  } 

  &:hover {
    transform: scale(1.05);    
    box-shadow: 0 5px 5px black;
  }

  /*  En celulares (portrait) las flechas van abajo junto con el botón del menú 
      también se reduce su tamaño
  */
  // @media (max-width: 600px) {
  //     top: initial;
  //     bottom: 0;
  //     width: 30px;
  //     height: 40px;
  //     background-size: 60px 35px;
  //     z-index: 7; //Justo encima de la barra de la barra del menú navigation
  //     background-image: url("../assets/imagenes_compartidas/flechas-nav-blan.png");
  // }
}

.flechas-nav-blan {
  background-image: url("../assets/imagenes_compartidas/flechas-nav-blan.png");
}
</style>
